import __var_0__ from '@stdlib/utils/define-read-only-property';
import __var_1__ from '@stdlib/number/float64/base/exponent';
import __var_2__ from '@stdlib/number/float64/base/from-binary-string';
import __var_3__ from '@stdlib/number/float64/base/from-words';
import __var_4__ from '@stdlib/number/float64/base/get-high-word';
import __var_5__ from '@stdlib/number/float64/base/get-low-word';
import __var_6__ from '@stdlib/number/float64/base/normalize';
import __var_7__ from '@stdlib/number/float64/base/set-high-word';
import __var_8__ from '@stdlib/number/float64/base/set-low-word';
import __var_9__ from '@stdlib/number/float64/base/signbit';
import __var_10__ from '@stdlib/number/float64/base/to-binary-string';
import __var_11__ from '@stdlib/number/float64/base/to-float32';
import __var_12__ from '@stdlib/number/float64/base/to-int32';
import __var_13__ from '@stdlib/number/float64/base/to-uint32';
import __var_14__ from '@stdlib/number/float64/base/to-words';
/**

*
* Copyright (c) 2018 The Stdlib Authors.
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*    http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/

'use strict';

/*
* When adding modules to the namespace, ensure that they are added in alphabetical order according to module name.
*/

// MODULES //
var setReadOnly = __var_0__;


// MAIN //

/**
* Top-level namespace.
*
* @namespace ns
*/
var ns = {};

/**
* @name exponent
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/number/float64/base/exponent}
*/
setReadOnly( ns, 'exponent', __var_1__);

/**
* @name fromBinaryString
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/number/float64/base/from-binary-string}
*/
setReadOnly( ns, 'fromBinaryString', __var_2__);

/**
* @name fromWords
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/number/float64/base/from-words}
*/
setReadOnly( ns, 'fromWords', __var_3__);

/**
* @name getHighWord
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/number/float64/base/get-high-word}
*/
setReadOnly( ns, 'getHighWord', __var_4__);

/**
* @name getLowWord
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/number/float64/base/get-low-word}
*/
setReadOnly( ns, 'getLowWord', __var_5__);

/**
* @name normalize
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/number/float64/base/normalize}
*/
setReadOnly( ns, 'normalize', __var_6__);

/**
* @name setHighWord
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/number/float64/base/set-high-word}
*/
setReadOnly( ns, 'setHighWord', __var_7__);

/**
* @name setLowWord
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/number/float64/base/set-low-word}
*/
setReadOnly( ns, 'setLowWord', __var_8__);

/**
* @name signbit
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/number/float64/base/signbit}
*/
setReadOnly( ns, 'signbit', __var_9__);

/**
* @name toBinaryString
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/number/float64/base/to-binary-string}
*/
setReadOnly( ns, 'toBinaryString', __var_10__);

/**
* @name float64ToFloat32
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/number/float64/base/to-float32}
*/
setReadOnly( ns, 'float64ToFloat32', __var_11__);

/**
* @name float64ToInt32
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/number/float64/base/to-int32}
*/
setReadOnly( ns, 'float64ToInt32', __var_12__);

/**
* @name float64ToUint32
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/number/float64/base/to-uint32}
*/
setReadOnly( ns, 'float64ToUint32', __var_13__);

/**
* @name toWords
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/number/float64/base/to-words}
*/
setReadOnly( ns, 'toWords', __var_14__);


// EXPORTS //
export default ns;

export { __var_1__ as exponent, __var_2__ as fromBinaryString, __var_3__ as fromWords, __var_4__ as getHighWord, __var_5__ as getLowWord, __var_6__ as normalize, __var_7__ as setHighWord, __var_8__ as setLowWord, __var_9__ as signbit, __var_10__ as toBinaryString, __var_11__ as float64ToFloat32, __var_12__ as float64ToInt32, __var_13__ as float64ToUint32, __var_14__ as toWords};